import { render, staticRenderFns } from "./BPlan.vue?vue&type=template&id=6f32431d&scoped=true"
import script from "./BPlan.vue?vue&type=script&lang=js"
export * from "./BPlan.vue?vue&type=script&lang=js"
import style0 from "./BPlan.vue?vue&type=style&index=0&id=6f32431d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f32431d",
  null
  
)

export default component.exports